import enPT from './en-PT.json.js';
import enUS from './en-US.json.js';

const messages = {
  'en-US': enUS,
  'en-PT': enPT
};

export { messages as default };
